import { createRouter, createWebHashHistory } from 'vue-router'
import store from 'shared/store/index';

const Index = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/Index')
const Login = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/Login')
const RequestResetPassword = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/RequestResetPassword')
const ResetPassword = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/ResetPassword')
const SignUp = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/SignUp')
const Verify = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/Verify')
const FacebookDisconnect = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/FacebookDisconnect')
const Profile = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/Profile')
const SetPassword = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/SetPassword')
const ChangePassword = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/ChangePassword')
const MyDetails = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/MyDetails')
const MySubscriptions = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/MySubscriptions')
const MyAnnualTickets = () => import(/* webpackChunkName: "account-pages" */ 'app/account/pages/MyAnnualTickets')

const routes = [
  {
    path: '/',
    component: Index,
    meta: { requiredAuth: true }
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/login/redirect/:returnTo',
    component: Login
  },
  {
    path: '/sign-up',
    component: SignUp
  },
  {
    path: '/verify/:userId/:verificationCode',
    component: Verify
  },
  {
    path: '/request-reset-password',
    component: RequestResetPassword
  },
  {
    path: '/reset-password/:userId/:resetCode',
    component: ResetPassword
  },
  {
    path: '/facebook-disconnect',
    component: FacebookDisconnect
  },
  {
    path: '/facebook-disconnect/:userId/:disconnectCode',
    component: FacebookDisconnect
  },
  {
    path: '/profiel',
    component: Profile,
    meta: { requiredAuth: true }
  },
  {
    path: '/set-password',
    component: SetPassword,
    meta: { requiredAuth: true }
  },
  {
    path: '/mijn-gegevens',
    component: MyDetails,
    meta: { requiredAuth: true }
  },
  {
    path: '/mijn-abonnementen',
    component: MySubscriptions,
    meta: { requiredAuth: true }
  },
  {
    path: '/mijn-jaarkaarten',
    component: MyAnnualTickets,
    meta: { requiredAuth: true }
  },
  {
    path: '/wachtwoord-wijzigen',
    component: ChangePassword,
    meta: { requiredAuth: true }
  }
]

function guard (to, from, next, userData) {
  if (to.meta && to.meta.requiredAuth) {
    if (!userData) {
      return next({ path: '/login' });
    }
  }
  if (userData && to.path === '/login') {
    return next({ path: '/' });
  }
  return next();
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const userData = store.getters['user/user'];
  if (!userData) {
    store.dispatch('user/get').then(userData => {
      return guard(to, from, next, userData)
    },
    () => {
      return guard(to, from, next, userData);
    }
    )
  } else {
    return guard(to, from, next, userData);
  }
});

export default router;
